import { baseApiSlice } from '../../commons/base-api.config';
import {
    API_GET_USER_DETAILS,
    API_MARK_USER_OLD,
    API_UPDATE_CURRENTLY_WORKING_BRAND_ID,
} from '../../constants/api';
import { HTTP_METHODS } from '../../constants/http';
import { IUpdateCurrentlyWorkingBrandIdRequest } from '../../interfaces/user.interface';

export const userApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            getUserDetails: builder.query<any, void>({
                query() {
                    return {
                        url: API_GET_USER_DETAILS,
                        method: HTTP_METHODS.GET,
                    };
                },
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response: { status: number; data?: any }) => {
                    return {
                        status: response.status,
                        error: response.data?.message || 'Server Error',
                    };
                },
            }),
            updateCurrentlyWorkingBrandId: builder.mutation<
                any,
                IUpdateCurrentlyWorkingBrandIdRequest
            >({
                query: (data) => {
                    return {
                        url: API_UPDATE_CURRENTLY_WORKING_BRAND_ID,
                        method: HTTP_METHODS.PATCH,
                        body: data,
                    };
                },
                transformResponse: (data: { result: any }) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            markUserOld: builder.mutation<any, void>({
                query: () => {
                    return {
                        url: API_MARK_USER_OLD,
                        method: HTTP_METHODS.PATCH,
                    };
                },
                transformResponse: (data: { result: any }) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
        };
    },
});

export const {
    useLazyGetUserDetailsQuery,
    useUpdateCurrentlyWorkingBrandIdMutation,
    useMarkUserOldMutation,
} = userApiSlice;
